import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';



export const TablePagination = ({setPage, page , totalRecords, ...props}) => {
    const totalPages = Math.ceil(totalRecords / 10);
    return (
        <Stack spacing={2}>
            <Pagination
                count={totalPages} 
                variant="outlined"
                shape="rounded"
                className='rounded-xl'
                size='large'
                page={page}
                onChange={(e, page) => { setPage(page);}}

            />
        </Stack>
    );
}